import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { prepareMicrofrontendManifest } from 'shared/mappers/microfrontend';
import {
  IGetHeaderMicrofrontendOptions,
  IGetSaveSearchMicrofrontendResponse,
  IGetSaveSearchMicrofrontendResponse200,
  fetchGetSaveSearchMicrofrontend,
} from 'shared/repositories/save-search-frontend';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { request } from 'shared/utils/request';

type TParameters = TRequestParamsWithoutHttpApi<IGetHeaderMicrofrontendOptions<IGetSaveSearchMicrofrontendResponse200>>;

export const fetchSaveSearchMicrofrontendManifest = async (
  context: IApplicationContext,
  parameters: TParameters,
): Promise<IMicrofrontendManifest | null> =>
  request<IMicrofrontendManifest | null, TParameters, IGetSaveSearchMicrofrontendResponse>(context, {
    parameters,
    domain: 'fetchSaveSearchMicrofrontendManifest',
    defaultValue: null,
    fetchFunction: fetchGetSaveSearchMicrofrontend,
    prepareFunction: prepareMicrofrontendManifest,
  });
